module.exports = __webpack_public_path__ + "img/slider-accueil-knett-bagel.1d16abf6.jpg";